const columns = [
  {
    title: '序号',
    width: '68px',
    align: 'center',
    fixed: 'left',
    customRender: ({ index }) => index + 1 + ""
  },
  {
    title: '订单信息',
    width: '290px',
    fixed: 'left',
    slots: { customRender: 'orderInfo' },
  },
  {
    title: '商品名称',
    slots: { customRender: 'goodsInfo' },
    width: 260,
  },
  {
    title: '订单金额',
    width:'150px',
    align: 'center',
    slots: { customRender: 'orderPrice' },
  },
  {
    title: '拍单订单号',
    align: 'center',
    width: '200px',
    slots: { customRender: 'purchasedOrderId' },
  },
  {
    title: '拍单账号',
    align: 'center',
    width: '220px',
    slots: { customRender: 'purchasedAccount' },
  },
  {
    title: '订单时间',
    align: 'center',
    width: '200px',
    slots: { customRender: 'OrderTime' },
  }
]

export default { columns }